/*
function isEmail(email) {
    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}
*/

$(document).ready(function(){

    $('a[href="#"]').click(function(e){
        e.preventDefault();
    });

    $('#change_password').click(function(){
        $('.password_change_wrapper').slideToggle();
    })

    /* close search suggest modal on overlay click  */

    $(document).on('keyup',function(e) {
        if (e.key === 'Escape'){  // esc
            if( $('body').hasClass('modal-open') ){
                modal_close();
            }
        }
    });
});
